// extracted by mini-css-extract-plugin
export var active = "_eq-7";
export var blink = "_eq-8";
export var dropDownSelector = "_eq-4";
export var dropDownWrapper = "_eq-3";
export var fakeCursor = "_eq-6";
export var fontSizeButton = "_eq-9";
export var formQuillEditor = "_eq-0";
export var pressed = "_eq-a";
export var qlBlank = "_eq-1";
export var textFormattingToolbar = "_eq-2";
export var textToolbarOption = "_eq-5";